import { Component, signal, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet, ActivatedRoute } from '@angular/router';

import { ToastComponent } from './shared/toast/toast.component';
import { FooterComponent } from './shared/footer/footer.component';
import { AuthModalComponent } from './shared/auth-modal/auth-modal.component';
import { AnalyticsService } from './services/analytics.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent, FooterComponent, AuthModalComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private analytics = inject(AnalyticsService);
  protected readonly title = signal('aarvya-fe');

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const ref = params['ref'];
      if (ref) {
        this.analytics.trackReferral(ref);
      }
    });
  }

  protected shouldShowFooter(): boolean {
    const url = this.router.url;
    return !url.startsWith('/sign-in') && !url.startsWith('/sign-up');
  }
}
